import './Card.css'

export default function Card({title, imagem, alt, features, textoWpp}){
    return(
        <div className="card">
            <img className='imagemCard' src={imagem} alt={alt}/>
            <div className="descricao">
                <h4>{title}</h4>
                <ul className='lista'>
                    {features.map((f)=>(
                    <li>{f}</li>
                    ))
                    }
                </ul>
            </div>
            <a href={`https://wa.me/5531996188853?text=${encodeURIComponent(textoWpp)}`} target="_blank" rel="noopener noreferrer" className='buttonCard'>Fale conosco!</a>   
        </div>
    )
}